import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 2,
}));
